import { render, staticRenderFns } from "./Acupuncture.vue?vue&type=template&id=efd6162a&scoped=true&"
import script from "./Acupuncture.vue?vue&type=script&lang=js&"
export * from "./Acupuncture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd6162a",
  null
  
)

export default component.exports